import { addYears, startOfYear } from "./date-fns";
import type { Time } from "./time";

export function startOfNextYear(time: Time): Date {
	return startOfYear(addYears(time, 1));
}
